import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import { addApi } from 'shared/src/api'
import { addPathParam } from 'shared/src/utils/addNavigate'
import { addDataLoadingFromPromise } from 'shared/src/utils/dataLoading'

import { addLoadingAndErrorIndicators } from 'utils/addLoadingAndErrorIndicators'
import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { setPageTitle } from 'utils/title'
import { EditStack } from './EditStack'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    rowGap: 24,
    columnGap: 14,
    paddingBottom: 24,
  },
})

export const EditsGrid: FC = flowMax(
  addDisplayName('EditsGrid'),
  addTranslationHelpers,
  addPathParam('username'),
  setPageTitle(({ username, t }) =>
    t('edits.creatorPageTitle', { creator: username })
  ),
  addApi,
  addDataLoadingFromPromise(
    'userLists',
    ({ username, api }) => api.users.userLists(username),
    [],
    ({ username }) => `${username}-user-lists`
  ),
  addLoadingAndErrorIndicators('userLists', { redirectTo404IfError: true }),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ userLists, classes }) => (
    <div className={classes.container}>
      {userLists.map((list, index) => (
        <EditStack list={list} key={list.id} stackIndex={index} />
      ))}
    </div>
  )
)
